export const environment = {
    production: false,
    // data_entry_url: 'http://venus.covetus.work/',
    // sign_pl_url: 'http://venus.covetus.work',
    // sign_pl_url_old: 'http://mercury.covetus.work',
    // sign_accounts_url: 'http://uranus.covetus.work',
    apiBaseURL: 'https://coreapi.uat.signpl.com/api/',
    apiURL: 'https://coreapi.uat.signpl.com/api/',
    apiV1URL: 'https://coreapi.uat.signpl.com/api/v1/',
    blazzerUrl: "https://account.uat.signpl.com",
    formVizzurl: "https://formwiz.uat.signpl.com",
    isSuperAdmin: false,


};
